import { render, staticRenderFns } from "./changePasswordPopup.vue?vue&type=template&id=353d0ae4&scoped=true&"
import script from "./changePasswordPopup.vue?vue&type=script&lang=js&"
export * from "./changePasswordPopup.vue?vue&type=script&lang=js&"
import style0 from "./changePasswordPopup.vue?vue&type=style&index=0&id=353d0ae4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "353d0ae4",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/code/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('353d0ae4')) {
      api.createRecord('353d0ae4', component.options)
    } else {
      api.reload('353d0ae4', component.options)
    }
    module.hot.accept("./changePasswordPopup.vue?vue&type=template&id=353d0ae4&scoped=true&", function () {
      api.rerender('353d0ae4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "common/components/changePasswordPopup.vue"
export default component.exports